var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1598.1 758.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#feba91;}.cls-2{fill:#fe7624;}.cls-3,.cls-7{fill:#fff;}.cls-10,.cls-4,.cls-8,.cls-9{fill:none;}.cls-4,.cls-7{stroke:#2e186a;}.cls-10,.cls-4,.cls-7,.cls-8,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-10,.cls-4,.cls-7{stroke-width:6px;}.cls-5{fill:#5d21d1;}.cls-6{fill:#2e186a;}.cls-10,.cls-8,.cls-9{stroke:#fe7624;}.cls-8{stroke-width:4.5px;}.cls-9{stroke-width:8px;}.cls-11{fill:#968bb4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solid_III",
    "data-name": "solid III"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shape",
    className: "cls-1",
    x: 73.32,
    y: 497.44,
    width: 1455.07,
    height: 257.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape-2",
    "data-name": "shape",
    className: "cls-2",
    d: "M943.73,88.21H619.5A9.86,9.86,0,0,0,609.66,98V297.55a9.86,9.86,0,0,0,9.84,9.83H746.17l-19.12,73.27H846.43L828,307.38H943.73a9.86,9.86,0,0,0,9.84-9.83V98A9.86,9.86,0,0,0,943.73,88.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "screen-2",
    "data-name": "screen",
    className: "cls-3",
    x: 626.12,
    y: 101.38,
    width: 297.99,
    height: 186.83,
    rx: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 785.11,
    cy: 340.91,
    rx: 14.43,
    ry: 15.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 817,
    y1: 307.64,
    x2: 832.96,
    y2: 378.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 746.48,
    y1: 307.21,
    x2: 827.27,
    y2: 307.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "cls-4",
    d: "M926.72,91.27a10.37,10.37,0,0,1,10.19,10.48V296.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "code_lines",
    "data-name": "code lines"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 738,
    y: 142.18,
    width: 9.71,
    height: 13.88,
    rx: 3.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 667.53,
    y: 142.18,
    width: 66.74,
    height: 13.88,
    rx: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 667.53,
    y: 206.64,
    width: 72.78,
    height: 13.88,
    rx: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 685.93,
    y: 185.18,
    width: 112.88,
    height: 13.88,
    rx: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 805.12,
    y: 185.18,
    width: 60.97,
    height: 13.88,
    rx: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 877.02,
    y: 163.72,
    width: 9.71,
    height: 13.88,
    rx: 3.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 667.53,
    y: 163.68,
    width: 116.72,
    height: 13.88,
    rx: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 751.98,
    y: 142.18,
    width: 66.74,
    height: 13.88,
    rx: 4.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 789.47,
    y: 163.64,
    width: 82.33,
    height: 13.96,
    rx: 4.57
  }))), /*#__PURE__*/React.createElement("g", {
    id: "woman_with_glasses",
    "data-name": "woman with glasses"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape-3",
    "data-name": "shape",
    className: "cls-6",
    d: "M618.83,376.9l15.34-25.63s-14.63-64.89-23.81-97.13c-8.22-28.89-27.4-36-41.73-31.89l-102,17.27c-.75-.08-1.5-.14-2.23-.16-17.86-.4-47.44,64.28-54.35,101.95,9.29-3,30.19-6.14,56.76-2.55.78-1.56,3.63-6.31,7.38-13,.44.76.87,1.5,1.3,2.22,6.3,10.5,23.44,46.13,34.94,49.74L618.9,381.1l-1.32-4.2A10,10,0,0,0,618.83,376.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M512.26,189.53l-3,1.94s-17.78,9.67-23.37-8.29c-4.23-13.63,8.84-17.92,15.4-19.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M553.61,213.82l-6.81,15.12,10.13-2.22c1.1,2,14.23,30.31-17.57,37.58-20.87,4.76-45-12.18-55.93-27.61l17.64-3.2,14.39-34.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M576,155.62c2.42,8.24,9.35,47.35-15.73,57s-48.61-9.77-57.53-33.85-3.33-47.63,12.41-54.14S558.38,96,576,155.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M550.33,187.37a17.76,17.76,0,0,0,11.13-1.58,1.59,1.59,0,0,1,2.28,1.2c.53,3.09.38,8.47-6.38,10.1-7.06,1.7-8.56-4.5-8.86-8A1.61,1.61,0,0,1,550.33,187.37Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "554.68 176.24 562.45 174.21 551.7 144.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M528.81,154s3.89-7.4,9.9-4.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M552.83,136.48s4.85-6.78,10.43-3.22"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 544.84,
    cy: 163.36,
    rx: 2.66,
    ry: 4.22,
    transform: "translate(-21.74 113.17) rotate(-11.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 570.41,
    cy: 158.26,
    rx: 2.66,
    ry: 4.22,
    transform: "translate(-20.19 118.22) rotate(-11.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 535.05,
    cy: 162.77,
    rx: 16.89,
    ry: 22.84,
    transform: "translate(-19.7 91.85) rotate(-9.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 578.84,
    cy: 154.35,
    rx: 16.89,
    ry: 22.84,
    transform: "translate(-17.67 99.06) rotate(-9.63)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 561.25,
    y1: 151.61,
    x2: 550.88,
    y2: 153.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 517.72,
    y1: 157.75,
    x2: 494.25,
    y2: 165.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-6",
    d: "M583.31,110.7c-19.14-39.21-51.95-16.9-73.92,5.42-17.09-.29-38.8,17-43.43,30.91-5.57,16.71-3.63,40.73,8,56.12,22.37,24.6,41.49,19.33,55.2,7.5-7.95-4.2-14.87-11-20.09-19.08-2,1-17.93,8.46-23.17-8.39-2.25-7.25.39-11.86,4.34-14.77,1.56.48,3.62.24,6.3-1,13.14-6,17.93-20.93,19.67-30.33l62.4-16.2A7.25,7.25,0,0,0,583.31,110.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_II",
    "data-name": "hand II"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M550.64,351c-26.65-1.31-87.95-9.84-87.95-9.84l1-2.74c-22.24-2.61-40.19-.56-50.19,2-3.09,8.76-4.32,16.28-2.62,21.28,2.23,6.61,9.8,12.19,16.7,13.19,57.41,8.33,125.72,2.09,125.72,2.09l19.36-14.84S551.83,351,550.64,351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M544.82,351a150.29,150.29,0,0,1,26.9,1.51c8.26,1.27,22.31,3.4,23.72,5.29,3.32,4.45-9.33,6.68-15.31,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M575,366.17c11.72,3.12,17.84,3.55,15.33-1-1.45-2.6-21-11.55-24.82-12.55s-24.72-2.35-24.72-2.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M560.4,359.14a136.68,136.68,0,0,1,14.08,5.17c6.13,2.76,9.81,5.82,9.38,7s-5,3.59-9,2.17c-5.62-3.1-18.24-6.28-18.24-6.28,1.32-.3,10.11,3.33,14.93,4.87s8.69,6.15-3,5.49L550.91,377"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M708.66,274.2s18.68-.55,30.91-7.7c7.29-4.26,16.74-10.11,17.2-12.63.86-4.74-10.67.1-12.5.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M721.89,261s10-5.22,14.42-10.49,7.43-9.4,6.61-10.45-6.51-.89-9.53,2.13c-3.81,5.44-15.49,11.24-15.49,11.24,1.29-.19,8.86-5.39,12.57-8.85s5.37-9.85-4.81-4.7c0,0-10.84,5.83-14.86,7.39,0,0-17,2.14-22.52,7.86h0c-3.7,3.86-32.57,33.29-54.22,51.83-12.52,8.1-46.8,67.82-14.22,68.08,6.74.25,15.42-4.18,18.87-9.11l64.93-90.57c10.39-1.67,17.8-4.33,22.78-7,6.45-3.51,26.1-19.79,26.47-21.93,1-5.71-8.73-5.54-15.91,3.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ponytail"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 480.55,
    cy: 217.44,
    rx: 28.77,
    ry: 25.04,
    transform: "translate(55.78 530.14) rotate(-60.71)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 510.66,
    cy: 243.42,
    rx: 20.8,
    ry: 18.1,
    transform: "matrix(0.17, -0.99, 0.99, 0.17, 183.61, 705.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 528.91,
    cy: 271.3,
    rx: 18.57,
    ry: 16.16,
    transform: "translate(4.95 552.05) rotate(-55.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 544.62,
    cy: 295.77,
    rx: 15.35,
    ry: 13.36,
    transform: "translate(-62.72 419.19) rotate(-39.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M547.57,329.52c6.66,3.52,7.74,8.25,7.22,12a1.93,1.93,0,0,0,3.17,1.73c7.62-6.87,19.29-20.22,9.69-30.94-4.53-5.06-12.69-5.67-18.84-.85S541.57,326.34,547.57,329.52Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 493.48,
    y1: 241.1,
    x2: 504.31,
    y2: 224.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 515.29,
    y1: 263.83,
    x2: 528.8,
    y2: 254.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 536.04,
    y1: 285.4,
    x2: 540.66,
    y2: 283.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 549.86,
    y1: 310.2,
    x2: 554.48,
    y2: 307.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "legs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M527.16,644.3l-20.8,67.61s36.59,9,32.75,40.07L449,751.52l25.78-115.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M649.55,641.75l-21.5,69.82s37.86,9.52,33.88,41.76l-93.43-.48,26.71-119.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M621,383.5H558.25l-2.3-3.64L531.5,383.5h-11l-.33,1.69L412.29,401.27c-.78,2.74-27.73,50.07-2.13,83.85,10.24,13.52,46.74,17,86.84,16.31L459.63,689h95.74l26.69-115.87L566.14,689.68h95.74L670,422.29S670,380,621,383.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ponytail_woman",
    "data-name": "ponytail woman"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "boot",
    className: "cls-6",
    d: "M247.1,597,227.32,706.6l.44,48.47h22.92L252,707.15s9.29,46.87,41.31,49,59.69-6.67,59.47-7.92c-.1-.63,1-10.06,2-19.2.94-8-6.68-15.76-14.88-15.29-12.31.72-28.46-.26-38.26-8.42-17.5-14.59,7.65-111,7.65-111Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boot-2",
    "data-name": "boot",
    className: "cls-6",
    d: "M364.64,601.32,366,755.07h22.91l1.36-47.92s9.3,46.87,41.32,49,59.68-6.67,59.47-7.92c-.11-.63,1-10.06,2-19.2.94-8-6.69-15.76-14.89-15.29-12.31.72-28.45-.26-38.25-8.42-17.5-14.59-15.28-120.62-15.28-120.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "shape-4",
    "data-name": "shape",
    className: "cls-2",
    d: "M341.92,383.72l7.23-.74c21,8.52,45,2.74,66.6-10.31-2.73-2.27-7.66-8.22-7.66-11.45,0-20.84,4.46-39.72,20.49-64l-32.07,20.54s-13.46-21-25.63-43.26c-1.24-15.1-4.33-28.44-10.39-37.2-18.62-22.11-60.56-19.43-60.56-19.43l-69.32-5.2-.44-.24c-12.87,0-30.4,13.71-32.32,28.57-3.58,27.65,5.13,64.44,8.84,96.33-.65,3.28-1.17,5.88-1.54,7.6,0,0-72.9,101.39-21.9,152.43.27.4,80.12-.53,80.12-.53l-32,179.54L429.72,680s21.63-179.29,17.14-199.17C437.76,440.51,341.92,383.72,341.92,383.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head-2",
    "data-name": "head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "earrings_back",
    "data-name": "earrings back"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M277.85,211.78c-6.39.79-12.79-6.75-14.37-17a25.14,25.14,0,0,1,1.73-14.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M366.16,208.67c-6.39.79-12.79-6.75-14.37-17a25.14,25.14,0,0,1,1.73-14.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ponytail-2",
    "data-name": "ponytail"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271,107c12.28-11.61,14.85-64.94-26.05-95.5C203.55-19.41,177.12,20.59,171.43,31s-7.65,37.26,27.43,58.15S257,120.29,271,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.41,127.75l-.78.65a11.6,11.6,0,0,1-15.83-1.2l-11.55-12.59a10.37,10.37,0,0,1,.87-15.13l.77-.65a11.62,11.62,0,0,1,15.84,1.2l11.54,12.59A10.37,10.37,0,0,1,293.41,127.75Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "ear",
    className: "cls-7",
    cx: 272.41,
    cy: 168.12,
    rx: 11.96,
    ry: 12.57,
    transform: "translate(3.43 341.66) rotate(-64.51)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ear-2",
    "data-name": "ear",
    className: "cls-7",
    cx: 358.73,
    cy: 164.07,
    rx: 11.96,
    ry: 12.57,
    transform: "translate(56.25 417.28) rotate(-64.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "neck",
    className: "cls-7",
    d: "M323.46,203.65l.69,17.85,15,3.29c.84,2.43,1.76,44.55-36.73,39.31-25.25-3.44-37.06-26-43.82-46.71l21.42,1.5.1-50.24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "face",
    className: "cls-7",
    cx: 316.08,
    cy: 163.52,
    rx: 39.71,
    ry: 51.04,
    transform: "translate(-24.34 59.8) rotate(-10.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose",
    className: "cls-4",
    d: "M319.68,175.64l7.56-.25a1.22,1.22,0,0,0,1.14-1.53l-5.45-20.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II",
    "data-name": "brow II",
    className: "cls-4",
    d: "M298.68,143.2s6.7-6,12.29-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow",
    className: "cls-4",
    d: "M329.25,141.3s8.56-3.21,12,3.34"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II",
    "data-name": "eye II",
    className: "cls-6",
    cx: 310.02,
    cy: 160.06,
    rx: 4.52,
    ry: 3.03,
    transform: "translate(139.96 464.72) rotate(-88.14)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye",
    className: "cls-6",
    cx: 338.25,
    cy: 161.13,
    rx: 3.02,
    ry: 4.54,
    transform: "translate(-10.76 24.86) rotate(-4.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair-2",
    "data-name": "hair",
    className: "cls-6",
    d: "M301.74,101.47l-.09.12c-12.92,1.88-27.35,7.81-35.38,16.44-14.23,15.3-7.69,48.17,6.81,50.4a32.87,32.87,0,0,0,3.62.36c-.13-.83-.24-1.66-.34-2.5a65.27,65.27,0,0,1-.39-9c19.76-7.38,19.72-37,19.69-39.47,4.19,3.34,9.68,9.06,8.26,15.32l43.71,2.76a63.69,63.69,0,0,1,8.16,24.85c0,.12,0,.23,0,.35,4.09-5.85,4.29-15,.86-24.63l14.75.93S385,87.49,301.74,101.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "earring_front",
    "data-name": "earring front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M361.72,170.11c6.45-1,11.86,7.59,13.46,17.95s-2.34,19.58-8.8,20.58l-.22,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M272.27,174.21c6.46-1,13,6.59,14.6,17s-2.34,19.58-8.8,20.57l-.22,0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "mouth",
    className: "cls-4",
    d: "M321.14,190.56S303.88,201.27,303,178Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.73,322.6s-13.58-6.21-20.56,6.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.56,317.17s-11.83-13.58-26.18,4.27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand-2",
    "data-name": "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352.65,301l15.71-6s12.3-13.57,17.73-17.64,16.11-3.57,8.92,2.72-8.22,10.08-8.22,10.08,18.92-5.51,29.32-12c10.63-6.63,8.32,4.75,8.32,4.75s8,1.1,4.93,5.22c0,0,6.15,3.52,0,7.05,0,0,8.72.92,3.73,6.13-3.63,7.42-28.81,21.48-44.26,20.34l-8.64,3.8-10.89,5.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M398.81,294S418,289.28,424.43,283"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M401.32,300.6c2.08-.92,17.4-3.74,27.11-13.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M403.79,307.43c4.35-1.85,13.9-1.31,25.64-11.69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "lines-2",
    "data-name": "lines",
    className: "cls-4",
    d: "M261.5,265c7.21,28.06,8.81,58.38,8.81,58.38l81.54-22.23L369,330.79s-19.69,9.5-60.8,30.34c-36.4,18.45-82.34,33.86-99.55-14.28"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "thinking_man",
    "data-name": "thinking man"
  }, /*#__PURE__*/React.createElement("g", {
    id: "legs-2",
    "data-name": "legs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boots"
  }, /*#__PURE__*/React.createElement("path", {
    id: "boot-3",
    "data-name": "boot",
    className: "cls-6",
    d: "M1016.64,658.5v94.64H894.26s-.38-34.72,56-41.12V661.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boot-4",
    "data-name": "boot",
    className: "cls-6",
    d: "M915.49,658.5v94.64H793.12s-.39-34.72,56-41.12V661.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "trousers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952.26,413.26l-93.32,61.11a72,72,0,0,0-18,45.59l-6.05,168.79h77s106.47,1.94,106.47-5.82c0-6.22,6.3-119,8.8-163.62a19.92,19.92,0,0,1,18.93-18.78c18.16-.89,45.22-2.16,57.1-2.53,93.23-3.25,68.3-41.72,57.28-69.1-4.26-10.57-8.38-20.64-11.63-28.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1047.86,406.38,940.79,450.7c-13.41,8.17-13.55,32.42-14.17,49.58l-6,188.47"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "shape-5",
    "data-name": "shape",
    className: "cls-5",
    d: "M1175.19,336.76c-27.73-165.24-72.85-141.9-95.87-141.12l-52.43,2.1a8.94,8.94,0,0,0-.23-2.06c-.43-1.91-2.47-3.45-5.1-4.67l0-.08c6.68-1.67,19.52-5.39,19.37-8.29-.22-4.09-25.82-2.13-33.68-1.64-4,.24-11.77,2.62-18.36,4.87a32.81,32.81,0,0,0-19.3,17.61c-1.43,3.18-5.71,14.14-7,17.25L946,213.23s-31.65,72.37-39,91.2a68.85,68.85,0,0,0-2.06,7.16C889.42,358,922.1,382.08,922.1,382.08l159.32,1.62-18.48,15.7c-2.71,3.1,86.89-3.88,90-3.49,1.59.19-6.47-12.09-14.71-24.14C1157.5,363.84,1176.42,352.08,1175.19,336.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines-3",
    "data-name": "lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1138,305.42s-14.71-6.85-34.84,6.94c0,0-22.72-38.66-20.32-59.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1024.24,349.1c2.18-1.2,79.49-36.48,79.49-36.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "962.14 320.7 992.78 233.63 983.32 229.42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "head-3",
    "data-name": "head"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "neck-2",
    "data-name": "neck",
    className: "cls-7",
    points: "1076.64 203.42 1058.37 156.76 1018.29 182.3 1023.18 204.87 1021.91 252.84 1076.64 203.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair_back",
    "data-name": "hair back",
    className: "cls-6",
    d: "M1002.36,105.59s33.95,21.62,17.32,41.69c0,0-7.41,8.38-13.49,6.69,0,0,4.5-7.12-.64-10.85,0,0-1.69,21.43-19.24,17,0,0,6.5-9.46,4.84-20.85C987.68,115.48,993.24,101.26,1002.36,105.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face-2",
    "data-name": "face",
    className: "cls-7",
    d: "M1072.77,139.89s6.84-41.81-35.46-49.33c-3.94-.7-31-5-36.06,17.46-3.41,15-4.15,31.24-3.83,43.87,0,.08.23,23.88,9.54,37.17s30.16,12.21,41.23,5.77,13.11-9.81,16.25-17.51,8.31-37.34,8.31-37.34Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "nose-2",
    "data-name": "nose",
    className: "cls-4",
    points: "1014.89 142.74 1010.57 163.25 1018.05 162.07"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II-2",
    "data-name": "eye II",
    className: "cls-6",
    cx: 1005.35,
    cy: 141.1,
    rx: 3.3,
    ry: 2.13,
    transform: "translate(771.38 1128.98) rotate(-84.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye-2",
    "data-name": "eye",
    className: "cls-6",
    cx: 1025.61,
    cy: 143.39,
    rx: 2.13,
    ry: 3.3,
    transform: "translate(-8.97 97.86) rotate(-5.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II-2",
    "data-name": "brow II",
    className: "cls-4",
    d: "M1037.69,128.67a9.78,9.78,0,0,0-9.11-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow-2",
    "data-name": "brow",
    className: "cls-4",
    d: "M1010,123s-7.31-3.36-10.57,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair_front",
    "data-name": "hair front",
    className: "cls-6",
    d: "M1039.78,108.45s-16.41,56,20.86,62c0,0,21.71,4,26.72-3.65,0,0-15.68-8.47-13.63-17.44,0,0,17.56,19.53,33.07,5.71,0,0-25.69-4.47-23.24-27.6C1085.32,110.9,1045.61,95,1039.78,108.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cap",
    className: "cls-2",
    d: "M1107.91,116.84l-22.69-3.6c-2.24-15.32-11-37.29-42.33-41.16-49-6-50.78,41.64-50.78,41.64l113.48,17.75a7.41,7.41,0,0,0,2.32-14.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth-2",
    "data-name": "mouth",
    className: "cls-4",
    d: "M1033.07,167.1s-3.15,7.23-13.37,5.55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_II-2",
    "data-name": "hand II"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M956.67,218.74c.52-1.27,1-2.49,1.37-3.65,2.11-5.51,3.93-9.89,5.5-13.37a32.76,32.76,0,0,1,19.3-17.6c6.59-2.26,14.33-4.63,18.36-4.88,7.86-.48,33.46-2.44,33.68,1.64.15,2.91-12.69,6.62-19.38,8.3l-5.34,20.44s-6.25.75-9.33,2.43c-6.3,3.44-12.52,9.13-17.06,8.63,0,0-.32,3.25-1.3,8.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1000.65,185.36s18.54,2.35,19.93,8.56-3.86,6.56-3.86,6.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1000,192.8s16.33,3.49,17.25,9.79-4.34,6.26-4.34,6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M998.86,202s19.57,4.52,12.07,11.43-11.27,6.15-11.27,6.15-5.36-3.41,3.29-8.71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand-3",
    "data-name": "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1025.48,349.37l-10.09,1.92c-1.22.23-21.76,13.29-21.76,13.29l21.2,13.69s1.55,1.54,33.64-.52C1046.18,369.71,1034.23,357.49,1025.48,349.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1021.4,350.87a155.69,155.69,0,0,0-27.62,3.8c-8.42,2-22.73,5.38-24,7.45-3,4.86,10.18,6.11,16,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M991.58,369c-11.83,4.2-18.1,5.16-15.89.28,1.27-2.81,20.68-13.67,24.55-15s25.29-4.49,25.29-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1006,360.56a143,143,0,0,0-14.08,6.5c-6.09,3.36-9.63,6.83-9.09,8s5.42,3.29,9.42,1.49c5.54-3.67,18.28-8,18.28-8-1.38-.19-10.14,4.29-15,6.27s-8.45,7.07,3.57,5.41l18.18-2.06"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hoodie_man",
    "data-name": "hoodie man"
  }, /*#__PURE__*/React.createElement("g", {
    id: "legs-3",
    "data-name": "legs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_II",
    "data-name": "shoe II",
    className: "cls-2",
    d: "M1229.8,621.89l1.34,81.61s-47,11-59.41,50.11l104-.08,16.56-151.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shoe",
    className: "cls-2",
    d: "M1119.49,626l-11.91,79.58s-44.18,10.64-55.88,47.35l97.71-.07,30.95-136.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "trousers-2",
    "data-name": "trousers",
    className: "cls-6",
    d: "M1454.89,455.62l-5-63.66-193.61-.32-3.69,21.78-29.93-.8c-75.81-3.44-87.92,53.74-87.92,53.74l-62.25,243.38,92.65.45,47.15-171.86-21.44,170.25,94.23,1.4,18.42-175.11c22.21-5.06,94.34-22,112.8-31.93C1435,496,1455.77,472.34,1454.89,455.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hoodie",
    className: "cls-2",
    d: "M1452.06,290.06a222.19,222.19,0,0,0-67.27-66.59c11.69-19.07,9.62-38.45-39.55-42.35-79.59-2.79-87.71,18.55-87.84,35.18-26.24,20.87-42.23,43.15-51.71,64.22-11.42-10.55-32.53-29.88-37.92-33.47-7.5-5-12.26,3.81-18.31.73s-8.12-4-8.12-4-5.26,18.61-20.17,23.67c0,0,.3,2.78,3.64,8.62s-3.87,10,1.47,17.19S1178,359.72,1178,359.72c5.59,5.53,18.57,25,32.71,19.08l0-1.27.57.73,100.1.48-2.68,16.58c126.83,12.16,117.88,69.86,153,47.13L1458,365.69C1470,351.25,1475,325.57,1452.06,290.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shirt",
    className: "cls-3",
    d: "M1354.45,202.49l12.67,8.53s-47.34,28.91-53.52,103.3c-4.11,49.42-5,106.8-5,106.8l-22,3.1s7.3-135-1.33-160.1-.74-53.35,5.1-57.92S1354.45,202.49,1354.45,202.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand_II-3",
    "data-name": "hand II"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1122.19,226.86c-.76-.51-23.55-15-29.47-16.53s-6.71,5.55,11.58,15.7a19.59,19.59,0,0,0-3.56,22c1.7,3.87,17.21,19.27,22.54,19.89s25.25-4.6,21.06-17S1133,234.09,1122.19,226.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1133.5,235.18s-19.69-7.78-21.69-6.65c-2.78,1.59.3,9.61,9,13.49,0,0-6.06,7.87-2.72,14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "welt",
    className: "cls-6",
    d: "M1123.22,276c-3.94-5.91-4.54-8.59-4.54-8.59,14.27-3.21,21.38-24.34,21.38-24.34s2.79.69,9.14,4.27c2.56,1.44,4.9.29,6.73,0,2.55,19.76-22.84,35.25-31.56,39.51C1123.31,282.78,1126.22,280.49,1123.22,276Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand-4",
    "data-name": "hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1291.11,327.75a156,156,0,0,0-27.72-2.95c-8.66-.08-23.36-.25-25.11,1.44-4.13,4,8.41,8.39,15.13,5.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1309.94,328.13c-6-.37-14.32-.86-24.76-1.42-1.24-.07-24.32,7.67-24.32,7.67l17.29,18.39s1,1.69,28.31,6.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1257.8,338.2c-12.49,1.23-18.81.65-15.49-3.56,1.91-2.42,23.36-8.29,27.44-8.68s25.63,1.73,25.63,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1273.83,333.45a144.52,144.52,0,0,0-15.23,2.92c-6.72,1.8-11,4.32-10.74,5.55s4.47,4.49,8.79,3.71c6.26-2.23,19.67-3.37,19.67-3.37-1.3-.52-10.88,1.72-16.06,2.48s-9.9,4.83,2.16,6.11l18.14,2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "welt-2",
    "data-name": "welt",
    className: "cls-6",
    d: "M1308.15,363.7c-5.93-2.24-7.83-4-7.83-4,7.69-12,0-31.9,0-31.9s2-.53,8.24-1.79a7.12,7.12,0,0,0,4.73-3.26c12.76,14.46,5.1,39.87,1.7,49.08C1312,369.17,1312.65,365.39,1308.15,363.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hoodie_lines",
    "data-name": "hoodie lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1391.2,306.3s-12.68,1.24-15.9,17.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1337.39,258.41s-13,26.94-14.73,45.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1277.37,259.59s6,25.78,4,44.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1394.42,379s-67.52-4.59-75.09-6.53-4.77-7.48-10.25-9.59-7.24-3.8-7.24-3.8c7.11-11.34,0-30.13,0-30.13s1.87-.51,7.62-1.69,3.89-7.11,11.68-7.79,74.63,6.94,74.63,6.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1208.59,280.13s16.87,8.53,26.76,23.08"
  })), /*#__PURE__*/React.createElement("path", {
    id: "shape_II",
    "data-name": "shape II",
    className: "cls-6",
    d: "M1385.13,222.91c-11.48,19.19-37.23,38.22-43.26,41a.59.59,0,0,0,0,.08c17.21.84,57.4-21.37,64.19-25.27C1397.72,232.48,1390.8,226.66,1385.13,222.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape-6",
    "data-name": "shape",
    className: "cls-6",
    d: "M1257.76,225.22c-.12-2.82-.42-6.07-.36-9.51h-.05q-7.38,5.82-13.89,11.79c5.2,10.08,15.74,25.36,27.24,32.46C1267.26,252.78,1258.54,243.23,1257.76,225.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head-4",
    "data-name": "head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ear-3",
    "data-name": "ear",
    className: "cls-7",
    d: "M1351,149.33s15,.29,12.32,13.72-19.26,5.66-19.26,5.66l2.22-19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face-3",
    "data-name": "face",
    className: "cls-7",
    d: "M1308.26,107c-4-.33-31-2-34,20.56s.23,47.54,2.74,58.93,54.35,6.12,57.28,5.1,6.43-4.45,6.43-4.45l7.11-34.7S1350.72,110.55,1308.26,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "neck-3",
    "data-name": "neck",
    className: "cls-7",
    d: "M1345.42,167.64l.94,28.15,8,9.14h0a229.62,229.62,0,0,0-46,40.17s-18.42-19.45-21.65-49.92l43.16,5.35,3.38-16.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "beard",
    className: "cls-11",
    d: "M1342.67,152.17c-2.57,2.49-9.46,16.84-11.14,23.53,0,0-17-5.62-41.46-6,0,0-13.31.26-18.62,1.8,0,0,1.15,23.7,11.94,36s33.62,8.84,44.32,1.46,12.48-10.9,15-18.79,9-37.32,9-37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair-3",
    "data-name": "hair",
    className: "cls-6",
    d: "M1349.67,157.24s7-10.91,9.77-22.25a23.39,23.39,0,0,0-12.26-26.6c-8.26-4-14.38-.86-14.38-.86s8.76-14.91-4.39-28.09a23.87,23.87,0,0,0-17.59-7,23.06,23.06,0,0,0-21,14s-17.19-31.57-52.42-12.89c-3.55,1.89-7.56,7.14-9.47,10.68-11.64,21.44,26.71,46.84,46.68,48.85,21.92,2.21,34.75-1.42,41.81-6.79C1311.16,129.48,1317.07,162.28,1349.67,157.24Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "nose-3",
    "data-name": "nose",
    className: "cls-4",
    points: "1290.93 160.61 1288.56 181.26 1295.84 179.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye_II-3",
    "data-name": "eye II",
    className: "cls-6",
    cx: 1282.29,
    cy: 159.18,
    rx: 2.12,
    ry: 3.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eye-3",
    "data-name": "eye",
    className: "cls-6",
    cx: 1301.76,
    cy: 158.64,
    rx: 2.12,
    ry: 3.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow-3",
    "data-name": "brow",
    className: "cls-4",
    d: "M1312.85,145.47a9.71,9.71,0,0,0-9.18-3.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_II-3",
    "data-name": "brow II",
    className: "cls-4",
    d: "M1284.24,141.52s-5.86-1.52-7.33,3.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth-3",
    "data-name": "mouth",
    className: "cls-4",
    d: "M1307,186.14s-1,6.26-6.75,5.25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "table"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 123.86,
    y: 380.78,
    width: 1348.21,
    height: 373.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 121.3,
    y: 380,
    width: 1352.39,
    height: 48.1
  })), /*#__PURE__*/React.createElement("line", {
    id: "line-2",
    "data-name": "line",
    className: "cls-4",
    x1: 3,
    y1: 755.01,
    x2: 1595.1,
    y2: 755.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.0d1145cdb624af5079e5e5a705f461da.svg";
export { ForwardRef as ReactComponent };